import { getFarmsPriceHelperLpFiles } from '@pancakeswap/farms/constants/priceHelperLps/getFarmsPriceHelperLpFiles'
import { ChainId } from '@pancakeswap/sdk'
import PoolsMantlePriceHelper from './pools/5000'
import PoolsMantleTestnetPriceHelper from './pools/5003'

export { getFarmsPriceHelperLpFiles }

export const getPoolsPriceHelperLpFiles = (chainId: ChainId) => {
  switch (chainId) {
    case ChainId.MANTLE:
      return PoolsMantlePriceHelper
    case ChainId.MANTLE_TESTNET:
      return PoolsMantleTestnetPriceHelper
    default:
      return []
  }
}
